// Static demo-mode fill-in data for LeaveRequest.component.jsx (the
// manager-facing "leave requests awaiting my approval" view).
// Shapes must match what LeaveRequestComponent's `managerRequests` /
// `companyMemberDetails` state expects — see LeaveRequest.config.jsx's
// `columnsConfig` cell renderers (row.* per request, reporter resolved via
// companyMemberDetails[row.userId]) and the component's own
// ReporterTemplete/ReportDateTempelate/TaskDateTempelate helpers.

// Firestore Timestamp-like stub — `rowData?.requestDate?.toDate?.()` is used
// throughout (optional chaining), so a plain object with `toDate()` works.
const toTimestamp = (isoString) => ({
  toDate: () => new Date(isoString),
});

// Anchored to "today" so the request/report dates never go stale (see
// UserAttendance.demoData.js for the same pattern).
const DAY_MS = 24 * 60 * 60 * 1000;
const daysFromNow = (n) => new Date(Date.now() + n * DAY_MS);
const isoAt = (daysOffset, hh, mm) => {
  const d = daysFromNow(daysOffset);
  d.setUTCHours(hh, mm, 0, 0);
  return d.toISOString();
};
const leaveDateAt = (daysOffset) => {
  const d = daysFromNow(daysOffset);
  return `${d.getUTCFullYear()}-${d.getUTCMonth() + 1}-${d.getUTCDate()}`;
};

// Consumed by LeaveRequest.config.jsx's `columnsConfig` cellRenderers and by
// the component's ReporterTemplete/ReportDateTempelate/TaskDateTempelate
// helpers. Leans toward "Pending" since this is the manager approval queue.
export const DEMO_MANAGER_LEAVE_REQUESTS = [
  {
    id: 'demo-mgr-leave-1',
    userId: 'demo-emp-1',
    comment: 'Traveling home for the weekend',
    type: 'Planned Leave',
    leaveDate: leaveDateAt(6),
    requestDate: toTimestamp(isoAt(-2, 9, 20)),
    assignee: 'demo-manager-1',
    teamId: 'demo-team-engineering',
    status: 'Pending',
  },
  {
    id: 'demo-mgr-leave-2',
    userId: 'demo-emp-2',
    comment: 'Feeling unwell, need rest',
    type: 'Sick Leave',
    leaveDate: leaveDateAt(2),
    requestDate: toTimestamp(isoAt(-1, 8, 5)),
    assignee: 'demo-manager-1',
    teamId: 'demo-team-engineering',
    status: 'Pending',
  },
  {
    id: 'demo-mgr-leave-3',
    userId: 'demo-emp-3',
    comment: 'Personal work at bank',
    type: 'Casual Leave',
    leaveDate: leaveDateAt(-10),
    requestDate: toTimestamp(isoAt(-12, 12, 0)),
    assignee: 'demo-manager-1',
    teamId: 'demo-team-sales',
    status: 'Approved',
  },
  {
    id: 'demo-mgr-leave-4',
    userId: 'demo-emp-4',
    comment: 'Family emergency, need a few days',
    type: 'Unpaid Leave',
    leaveDate: leaveDateAt(-28),
    requestDate: toTimestamp(isoAt(-30, 7, 30)),
    assignee: 'demo-manager-1',
    teamId: 'demo-team-support',
    status: 'Rejected',
  },
  {
    id: 'demo-mgr-leave-5',
    userId: 'demo-emp-1',
    comment: 'Long weekend trip planned',
    type: 'Planned Leave',
    leaveDate: leaveDateAt(18),
    requestDate: toTimestamp(isoAt(-3, 10, 40)),
    assignee: 'demo-manager-1',
    teamId: 'demo-team-engineering',
    status: 'Pending',
  },
  {
    id: 'demo-mgr-leave-6',
    userId: 'demo-emp-2',
    comment: 'Dentist appointment in the morning',
    type: 'Sick Leave',
    leaveDate: leaveDateAt(4),
    requestDate: toTimestamp(isoAt(-1, 6, 50)),
    assignee: 'demo-manager-1',
    teamId: 'demo-team-engineering',
    status: 'Pending',
  },
];

// Consumed by the "Reporter" column / ReporterTemplete (`companyMemberDetails
// [rowData?.userId]` → userName || userEmailid) — matches the uid → details
// map shape produced by getTeamMemberDetails. IDs/names/emails match the
// canonical roster in EmployeeList.demoData.js.
export const DEMO_COMPANY_MEMBER_DETAILS = {
  'demo-emp-1': {
    userName: 'Rachel Turner',
    userEmailid: 'rachel.turner@meridianlabs.com',
  },
  'demo-emp-2': {
    userName: 'Michael Chen',
    userEmailid: 'michael.chen@meridianlabs.com',
  },
  'demo-emp-3': {
    userName: 'Sarah Johnson',
    userEmailid: 'sarah.johnson@meridianlabs.com',
  },
  'demo-emp-4': {
    userName: 'David Kim',
    userEmailid: 'david.kim@meridianlabs.com',
  },
};
